module.exports = __webpack_public_path__ + "static/school_year-079d66c901d224dd0a7a0c0a354a4ea6.png";